// src/hooks/useKeepScreenOn.js
// Filepath: // src/hooks/useKeepScreenOn.js
import { useEffect } from "react";
import { Native } from "../utils/native";

/**
 * keep=true  -> Disables screensaver while mounted; re-enables on unmount.
 * keep=false -> Explicitly enables screensaver on mount (idempotent), no cleanup.
 */
export function useKeepScreenOn(keep = true) {
  useEffect(() => {
    if (keep) {
      Native.disableScreensaver();
      return () => Native.enableScreensaver();
    } else {
      // Be explicit: ensure screensaver is allowed when entering this scene.
      Native.enableScreensaver();
      return undefined;
    }
  }, [keep]);
}
